import React, {
	useState
}from 'react'
import {
	Form, Input
}from 'antd'
import ModalTemplateMessages from '../../containers/MessageTemplates/ModalTemplateMessages'
import CustomButton from '../ButtonCustom'
import "./style.css"
import i18nLocal from './localization'

const { TextArea } = Input

const TextAreaWithTemplateButton = (({
	isRu, form, name, disabled, rowsNumber, required, textAreaWithTemplateLabel, textAreaWithTemplateMessage, ...otherProps
}) => {
	const [visibleTemplate, setVisibleTemplate] = useState(false)

	function setTemplateText(text){
		form.setFieldsValue({[name]: text})
		setVisibleTemplate(false)
	}

	return (
        <>
            <Form.Item
				label={
				    (<div className="label-template"> 
						<span>
							{ textAreaWithTemplateLabel 
							  ? textAreaWithTemplateLabel
							  : i18nLocal.textAreaWithTemplateLabel[isRu] }
						</span>
						{	!disabled &&
						<CustomButton
							type="grey"
							onClick={ () => setVisibleTemplate(true) }
						>
							<span>
								{ i18nLocal.textAreaWithTemplateButtonLabel[isRu] }
							</span>
						</CustomButton>}
					</div>)
				}
				name={name}
				rules={[{
					required : required,
					whitespace: required,
					message  : textAreaWithTemplateMessage
							   ? textAreaWithTemplateMessage
							   : i18nLocal.textAreaWithTemplateMessage[isRu] 
				}]}
			>
				<TextArea
					{...otherProps}
					disabled={ disabled }
					rows={ rowsNumber }
				/>
			</Form.Item>
				<ModalTemplateMessages
					getText={ setTemplateText }
					isRu={ isRu }
					setVisibleTemplate={ setVisibleTemplate }
					visibleTemplate={ visibleTemplate }
				/>
        </>
    )
})
export default TextAreaWithTemplateButton